import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { CreateContactStatusRequest } from '../../types/ContactStatus';
import {
    requestCreateUserContactStatuses,
    requestDeleteUserContactStatuses,
    requestUpdateUserContactStatuses,
    requestUserContactStatuses,
} from '../userContactStatuses/userContactStatuses';

export function useUserContactStatuses() {
    return useQuery({
        queryKey: [`userContactStatuses`],
        queryFn: async () => (await requestUserContactStatuses()).data,
    });
}

export function useCreateUserContactStatuses() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (status: CreateContactStatusRequest) =>
            (await requestCreateUserContactStatuses(status)).data,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [`userContactStatuses`] });
        },
    });
}

export function useDeleteUserContactStatuses() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (statusId: number) => await requestDeleteUserContactStatuses(statusId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [`userContactStatuses`] });
        },
    });
}

export function useUpdateUserContactStatuses() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (status: CreateContactStatusRequest) =>
            await requestUpdateUserContactStatuses(status),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [`userContactStatuses`] });
        },
    });
}
